<template>
    <div>
        <div class="top_texts">
            <h3>Kies het door u gewenste abonnement</h3>
        </div>
        <div>
            <div v-for="offer in offers" :key="offer.urlsafe" class="offer"
                 @click="contract.original_offer = offer.urlsafe"
                 :class="{selected: offer.urlsafe === contract.original_offer}">
                <div style="width: 10%;">
                    <input type="radio" name="offer_select" :value="offer.urlsafe"
                           v-model="contract.original_offer">
                </div>
                <div style="width: 90%;">
                    <h4 v-if="offer.name" v-html="offer.name" style="padding: 0; margin: 0;"></h4>
                    <div v-if="offer.description" v-html="offer.description"></div>
                    <div v-if="offer.duration_in_months">
                        Looptijd: {{ $duration_string(offer.duration_in_months) }}
                    </div>
                    <div v-if="offer.discount_description" style="color: red;"
                         v-html="offer.discount_description"></div>
                </div>
            </div>
        </div>
        <div>
            <button class="btn btn-primary pull-right" @click="set_info()"
                    :class="{'is-disabled': working}">
                Volgende stap
                <span v-if="working">
                    <font-awesome-icon :icon="['fal', 'spinner']" spin></font-awesome-icon>
                </span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        contract: {},
        offers: {
            type: Array,
        },
        working: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        set_info() {
            const self = this;

            let hide_iban_field_set = false;
            self.offers.forEach((offer) => {
                if (offer && offer.urlsafe === self.contract.original_offer) {
                    hide_iban_field_set = true;
                    self.contract.hide_iban_field = offer.hide_iban_field || false;
                }
            });

            if (!hide_iban_field_set) {
                self.contract.hide_iban_field = false;
            }

            self.$emit('next_step');
        },
    },
};
</script>

<style scoped="scoped">
.offer {
    text-align: initial;
    display: flex;
    align-items: center;

    background-color: white;

    border-width: 1px;
    border-style: solid;
    border-color: #ccc;
    border-radius: 5px;

    margin: 15px 0;
    padding: 15px;

    cursor: pointer;
}

.offer:hover {
    background-color: #FCFCFC;
}

.offer.selected {
    background-color: #e0eaf4;
    border-color: #337ab7;
}
</style>
